import React from "react";
import { TCText } from "../../../components/tcText/TCText";
import { TeamWithScores } from "../../../apis/types";
import { Colors } from "../../../utils/colors";

type props = {
  team?: TeamWithScores;
  isCurrentUserTeam: boolean;
};

export const TeamPlayerPhoneNumbers: React.FC<props> = ({
  team,
  isCurrentUserTeam,
}) => {
  return (
    <div style={{ flex: 1 }}>
      <TCText
        value={team?.playerA.phoneNumber ? team?.playerA.phoneNumber : "N/A"}
        // numberOfLines={1}
        style={{
          fontSize: 10,
          fontWeight: isCurrentUserTeam ? 600 : 500,
          color: isCurrentUserTeam ? Colors.green : Colors.grey,
          //   overflow: "hidden",
          //   textOverflow: "ellipsis",
          textAlign: "center",
        }}
      />
      <TCText
        value={team?.playerB.phoneNumber ? team?.playerB.phoneNumber : "N/A"}
        style={{
          fontSize: 10,
          fontWeight: isCurrentUserTeam ? 600 : 500,
          color: isCurrentUserTeam ? Colors.green : Colors.grey,
          marginTop: -3,
          textAlign: "center",
        }}
      />
    </div>
  );
};
